import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { finalizeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    const finish = (path) => {
      // Clean fragment so the next reload doesn't re-trigger
      window.history.replaceState(null, "", window.location.pathname);
      navigate(path, { replace: true });
    };

    if (!sessionId) {
      finish("/login");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        finalizeGoogleSession(data);
        finish("/");
      } catch (e) {
        console.error("Google session exchange failed", e);
        finish("/login?error=google");
      }
    })();
  }, [navigate, finalizeGoogleSession]);

  return (
    <div className="hero-theme min-h-screen flex flex-col items-center justify-center text-slate-900">
      <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
      <p className="mt-3 text-sm font-bold tracking-wide uppercase text-slate-500">
        Securing your hero shield…
      </p>
    </div>
  );
}
